export default __webpack_public_path__ + "static/media/map.5ffa3d19.png";